import React from 'react';
import { AuthLayout } from '../auth-layout.component';
import { CompleteRegistration } from './complete-registration.view';

export const CompleteRegistrationScreen = (): React.ReactElement => {
    return <AuthLayout component={<CompleteRegistration />} />;
};
